import { render, staticRenderFns } from "./createPlugin.vue?vue&type=template&id=0c6b8c5b&scoped=true"
import script from "./createPlugin.vue?vue&type=script&lang=js"
export * from "./createPlugin.vue?vue&type=script&lang=js"
import style0 from "./createPlugin.vue?vue&type=style&index=0&id=0c6b8c5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6b8c5b",
  null
  
)

export default component.exports